// extracted by mini-css-extract-plugin
module.exports = {"mainInfo":"styles_mainInfo__jb6DN","infoList":"styles_infoList__afK_h","contentAmount":"styles_contentAmount__Ti_cj"};